export var IdBadgePosition;
(function (IdBadgePosition) {
    IdBadgePosition["Right"] = "right";
    IdBadgePosition["ExtremeRight"] = "extreme-right";
    IdBadgePosition["Left"] = "left";
    IdBadgePosition["ExtremeLeft"] = "extreme-left";
    IdBadgePosition["TopRight"] = "top-right";
    IdBadgePosition["TopLeft"] = "top-left";
    IdBadgePosition["GridItemTopLeft"] = "grid-item-top-left";
    IdBadgePosition["BottomRight"] = "bottom-right";
    IdBadgePosition["BottomLeft"] = "bottom-left";
    IdBadgePosition["BottomCenter"] = "bottom-center";
    IdBadgePosition["Bottom"] = "bottom";
})(IdBadgePosition || (IdBadgePosition = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/badge/IdBadgePosition.ts
// module id = 41
// module chunks = 3